import { useState, useEffect, useCallback } from "react";
import { Bell, CheckCheck, TrendingUp, Wallet, ShieldCheck, Gift, LifeBuoy, Bot } from "lucide-react";
import api from "../lib/api";
import { timeAgo, clsx } from "../lib/format";
import { Button } from "../components/ui/button";

const ICONS = { trade: TrendingUp, deposit: Wallet, withdrawal: Wallet, kyc: ShieldCheck, referral: Gift, support: LifeBuoy, bot: Bot };

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = useCallback(() => api.get("/notifications").then((r) => setItems(r.data.items)), []);
  useEffect(() => { load(); }, [load]);

  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="p-4 lg:p-8 space-y-6 max-w-2xl">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2"><Bell className="h-6 w-6 text-brandblue" /><h1 className="font-display text-3xl font-extrabold tracking-tight">Notifications</h1></div>
        <Button onClick={markAll} data-testid="mark-all-read-btn" variant="outline" className="border-white/10 bg-fx-s1 gap-2"><CheckCheck className="h-4 w-4" /> Mark all read</Button>
      </div>

      <div className="rounded-xl bg-fx-s1 border border-white/5 divide-y divide-white/[0.03]">
        {items.length === 0 && <div className="px-5 py-12 text-center text-fx-s3">You're all caught up.</div>}
        {items.map((n) => {
          const Icon = ICONS[n.type] || Bell;
          return (
            <div key={n.id} data-testid={`notif-${n.id}`} className={clsx("flex items-start gap-3 px-5 py-4", !n.read && "bg-brandblue/[0.04]")}>
              <div className="h-9 w-9 rounded-lg bg-fx-base grid place-items-center text-brandblue shrink-0"><Icon className="h-4 w-4" /></div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-semibold">{n.title}</span>
                  {!n.read && <span className="h-2 w-2 rounded-full bg-brandblue" />}
                </div>
                <p className="text-sm text-fx-s3 mt-0.5">{n.message}</p>
                <div className="text-xs text-fx-s3 mt-1">{timeAgo(n.created_at)}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
